import PIA from 'actions/dod/dodPersonalInformationActions';

export function dodPersonalInformationUpdateField(f) {
    return { type: PIA.UPDATE_DOD_PERSONAL_INFORMATION_FIELD, payload: f };
}

export function dodPersonalInformationUpdateTitle(t) {
    return { type: PIA.UPDATE_DOD_PERSONAL_INFORMATION_TITLE, payload: t };
}
